import PropTypes from 'prop-types'
import { useLocation, useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import LocationPicker from '../../components/locationPicker/locationPicker';
import FlightTimePicker from '../../components/flightTimePicker/flightTimePicker';
import TemperaturePicker from '../../components/temperaturePicker/temperaturePicker';
import { destinationTraits, baseRoutes } from '../../appSettings';

const DestinationTraitsView = ({ selectedDestinationTrait }) => {
  const location = useLocation();
  const navigate = useNavigate();

  switch (selectedDestinationTrait) {
    case null:
      /*
        selectedDestinationTrait = null means the value hasn't yet been initialized
        during init setup (parsed from the url). Just null-return it and wait for 
        it to be set
      */
      return null;
    case destinationTraits.LOCATION:
      return <LocationPicker />
    case destinationTraits.FLIGHT_TIME:
      return <FlightTimePicker />
    case destinationTraits.TEMPERATURE:
      return <TemperaturePicker />
    default:
      // With react-router-dom 6.X we got an endless-loop issue where this was triggered nonstop
      if (location.pathname !== `/${baseRoutes.CONGRATULATIONS}`) {
        navigate(`/${baseRoutes.CONGRATULATIONS}`);
      }
      return null;
  }
}

DestinationTraitsView.propTypes = {
  selectedDestinationTrait: PropTypes.string,
}

DestinationTraitsView.defaultProps = {
  selectedDestinationTrait: destinationTraits.SURPRISE,
};

const mapStateToProps = ({ siteSettings }) => {
  return {
    selectedDestinationTrait: siteSettings.filters.selectedPreference,
  };
};

export default connect(mapStateToProps)(DestinationTraitsView)